import { useLocation } from 'react-router-dom';
import { useEffect } from "react";
import { createWidget } from '@sber-ecom-core/sberpay-widget';
// import { Helmet } from "react-helmet";
// import { useSelector } from 'react-redux';

const Sberpay = () => {
  const widget = createWidget("PRODUCTION");
  const location = useLocation();
  const backUrl = window.location.origin + "/purchases";
  const params = new URLSearchParams(location.search);
  const allParams = Object.fromEntries(params.entries());

  const handleClick = () => {
    const params = {
        bankInvoiceId: allParams.orderId, // '729a0130-968a-41dc-883e-6918c8cc06c1'
        backUrl,
    };
    widget.open(params);
  };  

  useEffect(handleClick, [])

  return<div />
}

// const Sberpay = () => {
//   const location = useLocation();
//   const company = useSelector((s) => s.company);
//   const user = useSelector((s) => s.user);


//   const onStart = () => {
//     const backUrl = window.location.origin + "/purchases";
//     const params = new URLSearchParams(location.search);
//     const allParams = Object.fromEntries(params.entries());
//     // console.log(user)
//     const data = {
//       // Селектор DOM-элемента на странице, куда будет добавлен виджет оплаты
//       selector: '#sbol-pay-container',
//       // Адрес, на который требуется перенаправить пользователя в случае успешной оплаты
//       returnUrl: backUrl,
//       // Адрес, на который требуется перенаправить пользователя в случае неуспешной оплаты
//       failUrl: backUrl,
//       // Индивидуальный открытый ключ продавца
//       token: '835bb6457fc0',
//       // Сумма платежа в копейках
//       amount: allParams.amount,
//       // Название магазина для отображения в окне виджета
//       shopName: company.name,
//       // Номер заказа в системе магазина
//       orderNumber: allParams.orderId,
//       phone: user.userLogin.slice(-10),
//       description: allParams.description,
//       flatButton: true,
//       rowView:true,
//     }
//     const sbolWidget = new window.SbolPay(data);
//   }

//   useEffect(() => {
//     const checkScript = () => {
//       if (window.SbolPay) {
//         onStart(); // Вызываем функцию
//       } else {
//         setTimeout(checkScript, 100); // Проверяем каждые 100мс
//       }
//     };

//     checkScript();
//   }, []);

//   return<div id='sbol-pay-container'>
//     <Helmet><script src="https://securecardpayment.ru/payment/modules/sbol-pay/sbol-pay.js" /></Helmet>
//   </div>
// }

export default Sberpay;